(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MyWebsiteController', MyWebsiteController);

    MyWebsiteController.$inject = ['$uibModalInstance', '$window', 'AlertToastService', '__config', 'entity'];

    function MyWebsiteController($uibModalInstance, $window, AlertToastService, __config, entity) {
        var vm = this;
        vm.copmpany = null;
        if (entity && entity.company)
            vm.company = entity.company;
        vm.closeModal = closeModal;
        vm.copyToClipboard = copyToClipboard;
        vm.gotoWebSite = gotoWebSite;
        vm.__config = __config;
        vm.companyUrl = null;
        vm.getUrl = getUrl;

        loadPage();

        function loadPage() {
            setWebsiteUrl();
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }

        function copyToClipboard() {

            if (!vm.companyUrl) {
                AlertToastService.error('خطا در کپی کردن !', null, null);
                return;
            }
            var text = vm.companyUrl;

            var body = angular.element($window.document.body);
            var textarea = angular.element('<textarea/>');
            textarea.css({
                position: 'fixed',
                opacity: '0'
            });

            textarea.val(text);
            body.append(textarea);
            textarea[0].select();
            document.execCommand('copy');
            AlertToastService.success('global.messages.info.copySuccess', null, null);
            textarea.remove();
        }

        function gotoWebSite() {

            if (vm.companyUrl) {
                window.open('http://' + vm.companyUrl, '_blank');
            }

        }

        function setWebsiteUrl() {
            if (vm.company && vm.company.keyUrl) {
                vm.planovinUrl = vm.company.keyUrl + '.' + vm.__config.domain;
                if (vm.company.hasDedicatedDomain && vm.company.domain) {
                    vm.companyUrl = vm.company.domain;
                } else {
                    vm.companyUrl = vm.company.keyUrl + '.' + vm.__config.domain;
                }
            }
        }

        function getUrl(url) {
            return 'https://' + url;
        }

    }
})();
